import project0 from "../images/project0.png";
import project3 from "../images/project3.png";
import project1 from "../images/project1.png";
import project2 from "../images/project2.png";

const ProjectState = () => {
  return [
    {
      name: "Athena-Gaming News",
      date: "september 2021",
      desc: "An API implementation of RAWG API using ReactJS which gives game details dynamically with time",
      technology: ["ReactJS", "Redux", "Thunk", "SCSS", "HTML5"],
      image: project0,
      link: "https://aryansgame.netlify.app",
      glink: "https://github.com/AryanShinde/Athena-GamingNews",
    },
    {
      name: "coolors",
      date: "July 2021",
      desc: "A WebApp which gives pallete from random choosen color and allows to make our own palette and also save it for the next visit!",
      technology: ["VanillaJS", "ChromaJS", "HTML5", "CSS3"],
      image: project1,
      link: "https://aryanscolorpalette.netlify.app",
      glink: "https://github.com/AryanShinde/ColorPalette",
    },
    {
      name: "Beat Producer",
      date: "July 2021",
      desc: "A WebApp which makes music/beats as per the colors choosen and can control the temp as well as mute any beat and select from options!",
      technology: ["VanillaJS", "HTML5", "CSS3"],
      image: project2,
      link: "https://beatproducer.netlify.app",
      glink: "https://github.com/AryanShinde/BeatProducer",
    },
    {
      name: "Studify",
      date: "June 2021",
      desc: "A College project which is for Students, by Students to manage all notes and deadlines by adding personal deadlines and specific pdf/Notes which can be downloaded",
      technology: ["Django", "Sqlite3", "HTML5", "CSS3", "JavaScript"],
      image: project3,
      link: "https://studify2.heroku.app",
      glink: "https://github.com/AryanShinde/Studify",
    },
  ];
};
export default ProjectState;
